import { NavLink } from "react-router-dom";
import ArticlePage from "./ArticlePage";
import { links, pages, navLinks } from "../data/site";
import vanakkamLogo from "../assets/Images/vanakkam-dsa-logo.png";
import {
  breadcrumbSchema,
  buildGraph,
  courseSchema,
  webpageSchema,
} from "../data/schema";

const VanakkamDsaPage = () => {
  const seo = pages.vanakkamDsa;
  const schema = buildGraph([
    webpageSchema(seo),
    courseSchema,
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Vanakkam DSA", path: seo.path },
    ]),
  ]);

  return (
    <ArticlePage
      seo={seo}
      schema={schema}
      theme="light"
      bigTitle="DSA"
      heading="Vanakkam DSA — founded by Hareesh Rajendran"
      related={navLinks.filter((link) => link.to !== seo.path)}
    >
      <img
        src={vanakkamLogo}
        alt="Vanakkam DSA logo"
        width="112"
        height="112"
        style={{
          display: "block",
          width: "7rem",
          height: "7rem",
          margin: "0 auto 1.2rem",
          objectFit: "contain",
        }}
      />
      <p>
        Vanakkam DSA is a Tamil cohort-based DSA and interview preparation
        platform founded by Hareesh Rajendran.
      </p>
      <p>
        The program is Tamil-first and built for students preparing for product
        company interviews. It covers data structures, algorithms, problem
        solving and interview preparation.
      </p>
      <ul>
        <li>1000+ paying students</li>
        <li>7 cohorts</li>
        <li>Taught entirely in Tamil</li>
        <li>DSA, interview preparation and product-company preparation</li>
      </ul>
      <p>
        Official website:{" "}
        <a
          href={links.vanakkamDsa}
          target="_blank"
          rel="noopener noreferrer me"
        >
          vanakkamdsa.com
        </a>
      </p>
      <p>
        Vanakkam DSA sits under Hayan Tech, where Hareesh owns the full funnel
        from YouTube to onboarding. Related work lives on the{" "}
        <NavLink to="/experience">experience</NavLink>,{" "}
        <NavLink to="/youtube">YouTube</NavLink> and{" "}
        <NavLink to="/projects">projects</NavLink> pages.
      </p>
    </ArticlePage>
  );
};

export default VanakkamDsaPage;
